export const faqConstants = {
  GETALL_REQUEST: 'FAQS_GETALL_REQUEST',
  GETALL_SUCCESS: 'FAQS_GETALL_SUCCESS',
  GETALL_FAILURE: 'FAQS_GETALL_FAILURE',

  GET_REQUEST: 'FAQS_GET_REQUEST',
  GET_SUCCESS: 'FAQS_GET_SUCCESS',
  GET_FAILURE: 'FAQS_GET_FAILURE',

  ADD_REQUEST: 'FAQS_ADD_REQUEST',
  ADD_SUCCESS: 'FAQS_ADD_SUCCESS',
  ADD_FAILURE: 'FAQS_ADD_FAILURE',

  UPDATE_REQUEST: 'FAQS_UPDATE_REQUEST',
  UPDATE_SUCCESS: 'FAQS_UPDATE_SUCCESS',
  UPDATE_FAILURE: 'FAQS_UPDATE_FAILURE',
}